// extracted by mini-css-extract-plugin
export default {"button":"AuthButton__button__gxRhP","standardType":"AuthButton__standardType__JYnNn","iconType":"AuthButton__iconType__NMQZU","text":"AuthButton__text__s6Jfe"};